import { useQuery } from '@tanstack/react-query';
import { adminConsoleAuthApi } from '../api/adminConsole';
import { getAdminConsoleToken } from '../lib/adminConsoleToken';
import { ADMIN_CONSOLE_ME_QUERY_KEY } from '../lib/adminSession';

/** The admin-api session (`GET /auth/me`), shared with Layout through the same query key. */
export function useAdminConsoleMe() {
  const hasToken = typeof window !== 'undefined' && !!getAdminConsoleToken();
  return useQuery({
    queryKey: ADMIN_CONSOLE_ME_QUERY_KEY,
    queryFn: () => adminConsoleAuthApi.me(),
    enabled: hasToken,
  });
}
